import React from 'react';

const Content = ({ children, showFooter = true }) => {
    return (
        <section className="clx-step__content" style={{ height: showFooter ? '320px' : '380px' }}>
            {children}
        </section>
    );
};

export default Content;
